import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { JupiterState } from '../@store/state';

export namespace JupiterGuards {
  export const relatedToGuard = (
    component: any,
    activatedRoute: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot,
    nextRouterState: RouterStateSnapshot,
  ) => {
    const store = inject(Store);
    const router = inject(Router);

    if (!store.selectSnapshot(JupiterState.getRelatedTo)) {
      router.navigateByUrl(`/space/void?return=${activatedRoute.url}`, { skipLocationChange: true });
      return false;
    }

    return true;
  };
}
